module.exports = __webpack_public_path__ + "img/spinning-circles.6446a921.svg";